export enum UserTradingAnalyticsPnlView {
  CALENDAR = 'CALENDAR::UserTradingAnalyticsPnlView',
  CHART = 'CHART::UserTradingAnalyticsPnlView',
}
